import React from "react";
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer
} from "recharts";

/** tick formatter */
function tickFormatter (value) {
	const limit = 25; // put your maximum character
	if (value.length < limit) return value;
	return `${value.substring(0, limit)}...`;
 }

 /** Grouped horizontal bar chart information */
export default function RenderGroupedHorizontalBarChart({
	data,
	config,
	GetSummary,
	filterData
}) {
	return (
		<div id={"horizontal-bar-chart"} className={"hsc-margin"}>
			<ResponsiveContainer width={"100%"} minHeight={450}>
				<BarChart data={data} layout={"vertical"}>
					<Legend
						layout={"horizontal"}
						verticalAlign={"bottom"}
						align={"center"}
						height={40}
					/>
					<CartesianGrid strokeDasharray={""} horizontal={false} />
					<XAxis axisLine={false} stroke={"#FFFFFF"} type={"number"} />
					<YAxis
						stroke={"#FFFFFF"}
						dataKey={config.trend.key}
						angle={-360}
						minTickGap={-200}
						tickMargin={25}
						tickLine={false}
						allowDataOverflow 
						width={120}
						type={"category"}
						orientation={"left"}
						tickFormatter={tickFormatter}
					/>

					<Tooltip
						cursor={{ fill: "transparent" }}
						wrapperStyle={{ color: "#003865", outline: "none" }}
						labelStyle={{ color: "#003865" }}
					/>
					{config.columns.map((con, index) => {
						return (
							<Bar
								key={con.value + index}
								dataKey={con.value}
								fill={con.color}
								layout={"vertical"}
								style={{ cursor: "pointer" }}
								onClick={data => { // this will needed for next release
									GetSummary(con, data, filterData);
								}}
								barSize={30}
								barCategoryGap={16}
								tick={{ wordWrap: "break-word" }}
							/>
						);
					})}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
}
